var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRotate = function SvgRotate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9973 2V4.53726C16.192 4.53726 19.8437 7.3608 20.7753 11.3286C21.7069 15.2965 19.6767 19.3778 15.8957 21.1402C12.1148 22.9025 7.56419 21.8901 4.95331 18.7049C2.34242 15.5198 2.34956 10.9877 4.97085 7.81065L6.72819 9.17456C4.75512 11.566 4.74838 14.9492 6.7132 17.3467C8.67841 19.7441 12.077 20.5004 14.9229 19.1739C17.7689 17.8474 19.2823 14.8011 18.5812 11.8145C17.88 8.82784 15.1543 6.71952 11.997 6.71952V9.3367L7.49815 5.66835L11.9973 2Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRotate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rotate.028e62a6.svg";
export { ForwardRef as ReactComponent };